"use strict";
/**
 * Market Selection Summary UI
 * What a click fans out to: the Markets trigger button and its +N badge, and
 * the Markets sheet's parallel-legs card, and the quick-add row.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateMarketSelectionSummary = updateMarketSelectionSummary;
const parallel_markets_service_1 = require("../services/parallel-markets-service");
const market_label_1 = require("../markets/market-label");
function formatMarketButtonLabel(market) {
    return market ? (0, market_label_1.marketLabel)(market) : "Markets";
}
/** A Novig id is a UUID; the other venues' ids are what the operator knows. */
function parallelLabel(market) {
    return market.venue === "novig" ? market.marketTitle || market.marketId : market.marketId;
}
/** Read-only: the side switch lives in the Parallel Markets modal. */
function renderParallelLegs(primaryMarket, parallelMarkets) {
    const list = document.getElementById("parallel-legs-list");
    if (!list)
        return;
    list.replaceChildren();
    if (parallelMarkets.length === 0) {
        const empty = document.createElement("p");
        empty.className = "parallel-legs-empty";
        empty.textContent = "None attached";
        list.appendChild(empty);
        return;
    }
    const primaryYes = primaryMarket?.yesSubtitle?.trim() || "YES";
    for (const leg of parallelMarkets) {
        const item = document.createElement("div");
        item.className = "parallel-legs-item";
        const title = document.createElement("span");
        title.className = "parallel-legs-title";
        title.textContent = parallelLabel(leg);
        const meta = document.createElement("span");
        meta.className = "parallel-legs-meta";
        const side = (0, parallel_markets_service_1.legSideLabels)(leg.sideNames)[leg.invert ? 1 : 0];
        meta.textContent = `${parallel_markets_service_1.PARALLEL_VENUE_TAGS[leg.venue]} · ${primaryYes} = ${side}`;
        item.append(title, meta);
        list.appendChild(item);
    }
}
/** One chip per sibling; a tap attaches it inverted (handlers/parallel-quick-add.ts). */
function renderQuickAdd(siblings) {
    const row = document.getElementById("parallel-quick-add");
    if (!row)
        return;
    // Rebuild only on a change: this runs on every order book poll, and a chip
    // replaced between press and release never gets the desktop click.
    const key = siblings.map((m) => `${m.venue}:${m.id}:${(0, market_label_1.marketLabel)(m)}`).join("|");
    if (row.dataset.renderKey === key)
        return;
    row.dataset.renderKey = key;
    row.replaceChildren();
    row.classList.toggle("hidden", siblings.length === 0);
    if (siblings.length === 0)
        return;
    const label = document.createElement("span");
    label.className = "parallel-quick-add-label";
    label.textContent = "Add opposite side";
    row.appendChild(label);
    for (const market of siblings) {
        const chip = document.createElement("button");
        chip.type = "button";
        chip.className = "btn btn-secondary btn-small parallel-quick-add-btn";
        chip.dataset.marketId = market.id;
        chip.dataset.venue = market.venue;
        chip.textContent = `+ ${(0, market_label_1.marketLabel)(market)}`;
        row.appendChild(chip);
    }
}
function updateMarketSelectionSummary(primaryMarket, parallelMarkets, siblings = []) {
    renderParallelLegs(primaryMarket, parallelMarkets);
    renderQuickAdd(siblings);
    const triggerButton = document.getElementById("market-selection-btn");
    if (triggerButton) {
        triggerButton.textContent = formatMarketButtonLabel(primaryMarket);
    }
    // "+N": a click reaches N more markets than the primary.
    const indicator = document.getElementById("parallel-legs-indicator");
    if (indicator) {
        indicator.classList.toggle("hidden", parallelMarkets.length === 0);
        indicator.textContent = `+${parallelMarkets.length}`;
    }
}
